import { render, staticRenderFns } from "./ItineraryReportSendModal.vue?vue&type=template&id=881e1724&scoped=true&style=top%3A%2020px"
import script from "./ItineraryReportSendModal.vue?vue&type=script&lang=ts"
export * from "./ItineraryReportSendModal.vue?vue&type=script&lang=ts"
import style0 from "./ItineraryReportSendModal.vue?vue&type=style&index=0&id=881e1724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881e1724",
  null
  
)

export default component.exports